
import { useContext } from 'react'
import MainCard from './Cards/MainCard'
import HealthCard from './Cards/HealthCard/MainCard'
import IMPInfoCrad from './Cards/IMPInfoCrad/MainCard'
import NetworkCard from './Cards/NetworkCard/MainCard';
import DebugInfoContext from '../context/DebugContext';
import { TIM_FAMILY_PRODUCTS } from '../config/config';
import moment from 'moment'
import BouncingDotsLoader from './dot-loader/BouncingDotsLoader'

const Container = () => {

    const { isDataReady } = useContext(DebugInfoContext)
    const { deviceIsValid } = useContext(DebugInfoContext)

    const { impInfoData } = useContext(DebugInfoContext)

    const { AgentData } = useContext(DebugInfoContext)
    const { healthInfoFromSPOT } = useContext(DebugInfoContext)
    const { riskInfoFromSPOT } = useContext(DebugInfoContext)

    const { assetInfoData } = useContext(DebugInfoContext)
    const { networkInfoFromSPOT } = useContext(DebugInfoContext)
    const { countAndCoordinatesData } = useContext(DebugInfoContext)
    const { occupancyData } = useContext(DebugInfoContext)

    const { headerData } = useContext(DebugInfoContext)
    const { formatMacAddress } = useContext(DebugInfoContext)

    // const epoctToUTC = (epoch) => {
    //     const date = new Date(epoch);
    //     const dateString = date.toUTCString();
    //     const dateArray = dateString.split(' ');
    //     const dayOfMonth = dateArray[1];
    //     const month = date.getUTCMonth() + 1
    //     const year = date.getUTCFullYear() % 100
    //     const timeString = date.toTimeString().split(' ')[0]; // HH:MM:SS format
    //     const [hours, minutes] = timeString.split(':');
    //     return `${dayOfMonth}-${month}-${year} ${hours}:${minutes}`;
    // };

    const isDeviceOffine = (string) => {
        var regex = new RegExp('device offline', "i");
        return regex.test(string);
    }

    const epoctToUTC = (epoch) => {
        if (epoch === undefined || epoch === null || epoch === 0) {
            return '--'; // Return '--' if epoch is undefined or null
        }
        const date = moment(epoch * 1000);
        const formattedDate = date.format('DD-MM-YY HH:mm'); // Format date as required

        // Calculate the time difference between the given epoch date and now
        // const timeAgo = date.fromNow();
        // (${ timeAgo })
        return `${formattedDate}`;

        // const date = moment(epoch);
        // const now = moment();
        // const diffInSeconds = now.diff(date, 'seconds');

        // if (diffInSeconds < 60) {
        //     return `${diffInSeconds} sec`;
        // } else if (diffInSeconds < 3600) {
        //     const diffInMinutes = Math.floor(diffInSeconds / 60);
        //     return `${diffInMinutes} min`;
        // } else if (diffInSeconds < 86400) {
        //     const diffInHours = Math.floor(diffInSeconds / 3600);
        //     return `${diffInHours} hr`;
        // } else {
        //     const diffInDays = Math.floor(diffInSeconds / 86400);
        //     return `${diffInDays} days`;
        // }
    };


    // let healthDataAgent = null;
    let riskDataSPOT = null;
    let cardDataForImp = null;
    let networkInfo = null;
    let assetinfo = null;
    let healthDataSPOT = null;
    let Firmware = null;
    let deviceNetworkSignature = null;
    let countAndCoordinatesInfo = null;
    let occupancyInfo = null;

    if (isDataReady) {
        // if (AgentData) {
        //     let heartBeat = null;
        //     let lastPresence = null;
        //     let lastConnected = null;


        //     if (AgentData?.config_last_refreshed) {
        //         heartBeat = AgentData?.config_last_refreshed
        //     }
        //     else if (AgentData?.lastUpdated) {
        //         heartBeat = AgentData?.lastUpdated
        //     }

        //     if (AgentData?.lastPresence) {
        //         lastPresence = AgentData?.lastPresence;
        //     } else if (AgentData?.last_pal_state_time) {
        //         lastPresence = AgentData?.last_pal_state_time;
        //     } else if (AgentData?.last_updated_state) {
        //         lastPresence = AgentData?.last_updated_state;
        //     }




        //     if (AgentData?.lastConnect) {
        //         lastConnected = AgentData?.lastConnect
        //     } else if (AgentData?.last_connect_time) {
        //         lastConnected = AgentData?.last_connect_time
        //     } else if (AgentData?.last_pal_state_time) {
        //         lastConnected = AgentData?.last_pal_state_time;
        //     }


        //     healthDataAgent = {
        //         I2C: { text: 'I2C Error State', value: String(AgentData?.i2cError).charAt(0).toUpperCase() + String(AgentData?.i2cError).slice(1) },
        //         battery: { text: 'Battery', value: AgentData?.battery ? (AgentData.battery).toFixed(2) + ' V' : '--' },
        //         heartBeat: { text: 'Heartbeat', value: heartBeat ? epoctToUTC(heartBeat) : '--' },
        //         lastPresence: { text: 'Last Presence', value: lastPresence ? epoctToUTC(lastPresence) : '--' },
        //         lastConnected: { text: 'Last Connected', value: lastConnected ? epoctToUTC(lastConnected) : '--' },
        //     };
        // }

        if (healthInfoFromSPOT?.updatedAt) {
            healthDataSPOT = {
                // I2C: { text: 'I2C Error State', value: String(healthInfoFromSPOT?.i2cError).charAt(0).toUpperCase() + String(healthInfoFromSPOT?.i2cError).slice(1) },
                battery: { text: 'Battery', value: healthInfoFromSPOT?.batteryVtg ? (healthInfoFromSPOT.batteryVtg).toFixed(2) + ' V' : '--' },
                heartBeat: { text: 'Heartbeat', value: epoctToUTC(healthInfoFromSPOT?.updatedAt) },
                lastPresence: { text: 'Last Presence', value: healthInfoFromSPOT?.lastPresence ? epoctToUTC(healthInfoFromSPOT?.lastPresence) : '--' },
                lastConnected: { text: 'Last Connected', value: epoctToUTC(healthInfoFromSPOT?.lastConnect) },
            };
        }

        if (riskInfoFromSPOT?.tzEpoch) {
            riskDataSPOT = {
                detailedRisk: { text: 'Detail Risk', value: riskInfoFromSPOT?.errorReason || '--' },
                stateChange: { text: 'State Change', value: epoctToUTC(riskInfoFromSPOT?.stateChangeTimestamp) },
            }
        }

        cardDataForImp = {
            deviceType: {
                text: 'Device Type', value: impInfoData?.devicegroupType === 'development_devicegroup' ? 'Development' : impInfoData?.devicegroupType === 'production_devicegroup' ? 'Production' : 'Unknown'
            },
            device: { text: 'Device Status', value: impInfoData?.device_online ? 'Online' : isDeviceOffine(riskInfoFromSPOT?.errorReason) ? 'Offline' : 'Sleep' },  // String(impInfoData.device_online).charAt(0).toUpperCase() + String(impInfoData.device_online).slice(1) },
            agent: { text: 'Agent Status', value: impInfoData?.agent_running ? 'Online' : 'Offline' }, // String(impInfoData.agent_running).charAt(0).toUpperCase() + String(impInfoData.agent_running).slice(1) },
            agentLink: { text: 'Agent ID', value: impInfoData?.agent_id },
            memory: { text: 'Free Memory', value: `${(impInfoData?.free_memory / 1000).toFixed(2)}Kb` },
            deviceId: { text: 'Device Id', value: impInfoData?.device_id }
        };

        // Z4 devices prioritize template 10 data (healthInfoFromSPOT) for WiFi information
        if (headerData?.isGen4Device && healthInfoFromSPOT?.wifiPara) {
            let selectedWifiData = healthInfoFromSPOT.wifiPara[0];

            // If multiple WiFi parameters exist, select the one with the strongest signal (smallest/less negative RSSI)
            if (healthInfoFromSPOT.wifiPara.length > 1 && Array.isArray(healthInfoFromSPOT.wifiPara[0])) {
                selectedWifiData = healthInfoFromSPOT.wifiPara.reduce((strongest, current) => {
                    if (!Array.isArray(current) || !Array.isArray(strongest)) return strongest;
                    const currentRssi = current[0];
                    const strongestRssi = strongest[0];
                    // Compare RSSI values: higher (less negative) is better signal
                    return currentRssi > strongestRssi ? current : strongest;
                }, healthInfoFromSPOT.wifiPara[0]);
            }

            const [rssi, gatewayEui, snr] = Array.isArray(selectedWifiData) ? selectedWifiData : [];

            networkInfo = {
                rssi: { text: 'RSSI', value: rssi ?? '--' },
                gatewayEui: { text: 'GatewayEui', value: gatewayEui || '--' },
                snr: { text: 'Snr', value: snr ?? '--' },
                gen4Mac: { text: 'Gen4 Mac', value: formatMacAddress(headerData?.GEN4MacId, false) }
            }
        }
        else if (AgentData?.wifi) {
            networkInfo = {
                currentWifi: { text: 'Current Network', value: AgentData?.wifi[0] },
                // lastWifi: { text: 'Last Network', value: AgentData?.lastWifi ? AgentData?.lastWifi[0] : '--' },
                ...(!headerData?.poeMacId && { rssi: { text: 'RSSI', value: AgentData?.wifi[2] } }), // If this is a PoE device, hiding the RSSI data.
                ...(!headerData?.poeMacId && { ssidChange: { text: 'SSID Change', value: AgentData?.ssidchange ? AgentData?.ssidchange[1] : '--' } }), // If this is a PoE device, hiding the SSID data
                wifiMac: { text: 'Wifi Mac', value: formatMacAddress(AgentData?.macaddress, false) },
                ...(headerData?.poeMacId && { poeMac: { text: 'Ethernet Mac', value: formatMacAddress(AgentData?.wifi?.[1], false) } }), // Only for PoE device
                ...(headerData?.GEN4MacId && { gen4Mac: { text: 'Gen4 Mac', value: formatMacAddress(headerData?.GEN4MacId, false) } }), // Only for Z4 device (fallback if no template 10 data)
            }
        }
        else if (healthInfoFromSPOT?.wifiPara) {
            networkInfo = {
                currentWifi: { text: 'Current WiFi', value: headerData?.productTypeInfo?.name === 'FLO' ? healthInfoFromSPOT?.wifiPara[1] : healthInfoFromSPOT?.wifiPara[0] },
                lastWifi: { text: 'Last WiFi', value: '--' },
                ...(!headerData?.poeMacId && { rssi: { text: 'RSSI', value: headerData?.productTypeInfo?.name === 'FLO' ? healthInfoFromSPOT?.wifiPara[0] : healthInfoFromSPOT?.wifiPara[3] } }), // If this is a PoE device, hiding the RSSI data.
                ...(!headerData?.poeMacId && { ssidChange: { text: 'SSID Change', value: '--' } }), // If this is a PoE device, hiding the SSID data
                wifiMac: { text: 'Wifi Mac', value: '--' },
                ...(headerData?.poeMacId && { poeMac: { text: 'Ethernet Mac', value: '--' } }), // Only for PoE device
            }
        }

        assetinfo = {
            spaceId: { text: 'Space Id', value: assetInfoData?.spaceId ? assetInfoData?.spaceId : '--' },
            itemId: { text: 'Item Id', value: assetInfoData?.itemId ? assetInfoData?.itemId : '--' },
            ownerId: { text: 'Owner Id', value: assetInfoData?.ownerId ? "..." + assetInfoData?.ownerId?.slice(-12) : '--', fullValue: assetInfoData?.ownerId || '--' },
            SpaceAssetId: { text: 'Space Asset Id', value: assetInfoData?.spaceAssetId ? "..." + assetInfoData?.spaceAssetId?.slice(-12) : '--', fullValue: assetInfoData?.spaceAssetId || '--' },
            deviceAssetId: { text: 'Device Asset Id', value: assetInfoData?.deviceAssetId ? "..." + assetInfoData?.deviceAssetId?.slice(-12) : '--', fullValue: assetInfoData?.deviceAssetId || '--' },
        }

        Firmware = {
            deviceGroup: { text: 'Device Group', value: healthInfoFromSPOT?.modelName ? healthInfoFromSPOT?.modelName : '--' },
            codeVersion: { text: 'Code Version', value: healthInfoFromSPOT?.buildVersion ? healthInfoFromSPOT?.buildVersion : '--' },
        }

        const allDashes = (cardData) => cardData && Object.values(cardData).every(field => field.value === '--');

        if (networkInfoFromSPOT) {
            deviceNetworkSignature = {
                fCnt: { text: 'Frame Count', value: networkInfoFromSPOT?.fCnt ?? '--' },
                fPort: { text: 'Frame Port', value: networkInfoFromSPOT?.fPort ?? '--' },
                fOptLen: { text: 'Frame Option Length', value: networkInfoFromSPOT?.fOptLen ?? '--' },
                dataRate: { text: 'Data Rate', value: networkInfoFromSPOT?.dataRate ?? '--' },
                frequency: { text: 'Frequency', value: networkInfoFromSPOT?.frequency ?? '--' },
            }
            if (allDashes(deviceNetworkSignature)) deviceNetworkSignature = null;
        }

        if (countAndCoordinatesData) {
            countAndCoordinatesInfo = {
                count: { text: 'Count', value: countAndCoordinatesData?.count ?? '--' },
                index: { text: 'Index', value: countAndCoordinatesData?.index ?? '--' },
            }
            if (allDashes(countAndCoordinatesInfo)) countAndCoordinatesInfo = null;
        }

        if (occupancyData) {
            occupancyInfo = {
                event: { text: 'Event', value: occupancyData?.value ?? '--' },
                timestamp: { text: 'Timestamp', value: occupancyData?.utcEpoch ? epoctToUTC(occupancyData?.utcEpoch) : '--' },
            }
            if (allDashes(occupancyInfo)) occupancyInfo = null;
        }

    }

    return (
        <>
            {isDataReady && deviceIsValid ?
                <>
                    <div className={`${headerData?.GEN4MacId ? 'ml-8 mr-0' : 'mx-8'} my-5 grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-3 gap-4`}>
                        <HealthCard
                            MainTitle={'Quick health check'}
                            SPOTHealthData={riskDataSPOT}
                        />
                        <NetworkCard
                            MainTitle={'Network Information'}
                            data={networkInfo}
                        />
                        {headerData?.GEN4MacId && (headerData?.productTypeInfo?.name?.toUpperCase()?.includes('TIM-4') || headerData?.productTypeInfo?.name?.toUpperCase()?.includes('ONE-Z4') || headerData?.productTypeInfo?.name === 'ONE-4') ? (
                            <IMPInfoCrad
                                MainTitle={'Device Network Signature'}
                                status={null}
                                data={deviceNetworkSignature || "No Data Available"}
                            />
                        ) : !headerData?.GEN4MacId ? (
                            <IMPInfoCrad
                                MainTitle={'Electric IMP Information'}
                                status={cardDataForImp.deviceType.value}
                                data={cardDataForImp}
                            />
                        ) : null}
                        <MainCard
                            MainTitle={'SPOT Information'}
                            data={assetinfo}
                        />
                        <MainCard
                            MainTitle={'Firmware information'}
                            data={Firmware}
                        />
                        <HealthCard
                            MainTitle={'Detailed health'}
                            SPOTHealthData={healthDataSPOT}
                        />
                        {TIM_FAMILY_PRODUCTS.includes(headerData?.productTypeInfo?.name?.toUpperCase()) && (
                            <>
                                <MainCard
                                    MainTitle={'Device Counts & Coordinates'}
                                    data={countAndCoordinatesInfo}
                                />
                                <MainCard
                                    MainTitle={'Device Occupancy'}
                                    data={occupancyInfo}
                                />
                            </>
                        )}
                    </div>
                </>
                :
                <>
                    {deviceIsValid === false
                        ?
                        <>
                            <div className='h-full flex justify-center items-center '>
                                <span className='text-sm md:text-base 2xl:text-lg text-center text-alertError'>Please search for a valid device</span>
                            </div>
                        </>
                        :
                        <>
                            <div className='h-full flex justify-center items-center '>
                                <BouncingDotsLoader />
                            </div>
                        </>
                    }
                </>
            }
        </>
    )
}

export default Container